import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import { isUndefined } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { ExclusionTime } from '../../shared/definitions';
import { ExclusionType } from '../definitions';
import useExclusionType from '../hooks/useExclusionType';

import {
  TXTWCL_Want_to_take_a_break_from_play_ELL,
  TXTWCL_XbXTake_a_break_from_playingX__ELL,
  TXTWCL_YouXre_self_excluded,
  TXTWCL_YouXre_self_excluded_Nationall_ELL,
  TXTWCL_YouXre_self_excluded_indefinit_ELL,
  TXTWCL_YouXre_taking_a_break,
  TXTWCL_You_are_permanently_self_exclu_ELL,
  TXTWCL_Your_Self_Exclusion_period_has_ELL
} from './ExclusionTitle.messages.json';

interface Props {
  daysRequested?: number;
  showExclusionConfirmationDE?: boolean;
  hasRequestedSE?: boolean;
}

export const getExclusionTitle = ({
  nationalExclusion,
  site,
  hasRequestedSE,
  daysRequested,
  exclusionType,
  showExclusionConfirmationDE
}: {
  nationalExclusion: boolean;
  site: Sites;
  hasRequestedSE?: boolean;
  daysRequested?: number;
  exclusionType?: ExclusionType;
  showExclusionConfirmationDE?: boolean;
}) => {
  const isSiteUK = site === Sites.UK;
  switch (true) {
    case showExclusionConfirmationDE:
    case nationalExclusion && site === Sites.DE:
      return TXTWCL_YouXre_taking_a_break;
    case nationalExclusion:
      return TXTWCL_YouXre_self_excluded_Nationall_ELL;
    case !isUndefined(daysRequested) && isSiteUK && daysRequested === ExclusionTime.Indefinite:
      return TXTWCL_You_are_permanently_self_exclu_ELL;
    case !isUndefined(daysRequested) &&
      site === Sites.US_PA &&
      daysRequested === ExclusionTime.Indefinite:
      return TXTWCL_YouXre_self_excluded_indefinit_ELL;
    case !isUndefined(daysRequested) && isSiteUK:
      return TXTWCL_Your_Self_Exclusion_period_has_ELL;
    case !isUndefined(daysRequested) &&
      ![Sites.FRA, Sites.GR, Sites.POR, Sites.DEN].includes(site) &&
      exclusionType === ExclusionType.SelfExclusion:
      return TXTWCL_YouXre_self_excluded;
    case !isUndefined(daysRequested) &&
      (site !== Sites.DEN || (site === Sites.DEN && !hasRequestedSE)):
      return TXTWCL_YouXre_taking_a_break;
    case [Sites.DEN, Sites.FRA, Sites.GR, Sites.US_PA, Sites.US_NJ, Sites.POR, Sites.DE].includes(
      site
    ):
      return TXTWCL_XbXTake_a_break_from_playingX__ELL;
    default:
      return TXTWCL_Want_to_take_a_break_from_play_ELL;
  }
};

const ExclusionTitle: React.FC<Props> = ({
  daysRequested,
  showExclusionConfirmationDE,
  hasRequestedSE
}) => {
  const site = useSelector(select.cms.getSiteId);
  const isBBR = useSelector(select.account.bannedByRegulator);
  const nationalExclusion = [Sites.ITA, Sites.DE].includes(site) && isBBR;
  const exclusionType = useExclusionType(daysRequested, nationalExclusion);

  return (
    <Translation
      {...getExclusionTitle({
        nationalExclusion,
        site,
        hasRequestedSE,
        daysRequested,
        exclusionType,
        showExclusionConfirmationDE
      })}
    />
  );
};

export default ExclusionTitle;
